import { memo } from 'react';

// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import { menuItems, adminMenuItems, superAdminMenuItems, administradorItems, contableItems, cajaItems, doctorItems } from 'menu-items';
import useAuth from '../../../../hooks/useAuth';

const isSuperUserFlag = (user) => {
    const currentUser = Array.isArray(user) ? user[0] : user;
    return Boolean(currentUser?.is_super === true || currentUser?.is_super === 't' || currentUser?.is_super === 1);
};

const filterMenuNode = (node, userRole, isSuperUser) => {
    if (node.superOnly && !isSuperUser) {
        return null;
    }

    if (node.hideForSuper && isSuperUser) {
        return null;
    }

    if (node.roles && !node.roles.includes(userRole)) {
        return null;
    }

    if (!node.children) {
        return node;
    }

    const children = node.children
        .map((child) => filterMenuNode(child, userRole, isSuperUser))
        .filter(Boolean);

    if (children.length === 0 && (node.type === 'collapse' || node.type === 'group')) {
        return null;
    }

    return { ...node, children };
};

const filterMenuItemsByRole = (items, userRole, isSuperUser) => {
    if (!Array.isArray(items)) return [];

    return items
        .map((item) => filterMenuNode(item, userRole, isSuperUser))
        .filter(Boolean);
};

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    menuItems.items= [];
    const { user, role } = useAuth();
    
    if (user !== null){
        if (role === "Propietario Empresas"){
            menuItems.items = adminMenuItems.items;
        }
        if (role === "Administrador Empresas"){
            menuItems.items = superAdminMenuItems.items;
        }
        if (role === "Administrador"){
            menuItems.items = administradorItems.items;
        }
        if (role === "Contable"){
            menuItems.items = contableItems.items;
        }
        if (role === "Cajero"){
            menuItems.items = cajaItems.items;
        }
        if (role === "Doctor"){
            menuItems.items = doctorItems.items;
        }
    }else{
        menuItems.items = [];
    }
    

    const navItems = filterMenuItemsByRole(menuItems.items, role, isSuperUserFlag(user)).map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default memo(MenuList);
